/**
 * Get the default values for a metric's configuration. Optionally pass in an existing config object to fill in any missing values
 */
export function metricConfigDefaults(config = {}) {
    return {
        numericType: 'none',
        allowRange: false,
        units: [],
        keywords: [],
        ...config,
        isInverseScale: config.isInverseScale ?? false,
        isPercent: config.isPercent ?? false,
    };
}
//# sourceMappingURL=metrics.js.map